import { createRoot } from "react-dom/client";
import App from "./App";

createRoot(document.getElementById("root")!).render(<App />);

console.log(window.location.host);

if ("serviceWorker" in navigator && !window.location.host.startsWith("localhost")) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js");
  });
}
